// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react'
import {
  Dialog,
  DialogProps,
  withStyles,
  WithStyles,
  DialogContent as MuiDialogContent,
  DialogActions as MuiDialogActions,
  IconButton,
  Close as CloseIcon,
} from '@zn-material-ui'
import classnames from 'classnames'
import { IReactNodeLike } from '@common/types/reactChildType'
import Button from '@components/Button'
import AdornedButton from '@components/AdornedButton'
import Title from './Title'
import styles from './styles'
import { transform } from '@utils/intl_lang'
const DialogContent = withStyles({
  root: {
    margin: 0,
    fontSize: 22,
    color: '#323232',
    textAlign: 'center',
    padding: '0 70px 0 70px !important',
    lineHeight: '30px',
    wordWrap: 'break-word',
    wordBreak: 'normal',
    overflowWrap: 'break-word',
  },
})(MuiDialogContent)

const DialogActions = withStyles({
  root: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 0,
    marginTop: 40,
  },
})(MuiDialogActions)

type footerRender = (props: any) => React.ReactNode
export interface IProps extends WithStyles<typeof styles> {
  okText?: string
  cancelText?: string
  onCancel?: () => void
  onOk?: (visibleHandler: (v: boolean) => void) => void
  title?: IReactNodeLike
  footer?: IReactNodeLike | string | footerRender // 底部栏-自定义
  confirmAndCancel?: boolean // 底部栏-取消，确认是否显示
  content?: IReactNodeLike | string
  disableBackdropClick?: boolean
  visible: boolean
  contentStyle?: {}
  showClose?: boolean
  loading?: boolean
  children?: React.ReactNode
  contentClass?: string
  dialogProps?: Omit<DialogProps, 'open'>
  userClose?: boolean
  networkState?: boolean
  isHiddenCancel?: boolean  // 取消按钮是否隐藏
  style?: {}
}

const ConfirmDialog = (props: IProps) => {
  const [open, setOpen] = React.useState(props.visible)

  React.useEffect(() => {
    setOpen(props.visible)
  }, [props.visible])

  const onCancel = () => {
    setOpen(false)
    if (props.onCancel) {
      props.onCancel()
    }
  }

  const onOk = () => {
    if (!props.userClose) {
      setOpen(false)
    }
    if (props.onOk) {
      props.onOk(setOpen)
    }
  }

  const footerShow = () => {
    if (props.footer === null) {
      return null
    }

    if (props.footer) {
      // 自定义footer
      return typeof props.footer === 'function'
        ? props.footer({ setOpen })
        : props.footer
    }

    if (props.confirmAndCancel) {
      // 确认框
      return (
        <div className={props.classes.dialogFooterBtn}>
          {
            props.isHiddenCancel ? null : (
              <Button className={props.classes.noBtn} onClick={onCancel}>
                {/* '取消' */}
                {props.cancelText ? props.cancelText : transform('cancel')}
              </Button>
            )
          }
          <AdornedButton
            loading={props.loading || false}
            onClick={() => {
              props?.onOk!(setOpen)
            }}
          >
            {/* '确定' */}
            {props.okText ? props.okText : transform('confirm')}
          </AdornedButton>
        </div>
      )
    }
    return (
      // alert弹窗
      <DialogActions>
        {/* '确定' */}
        <Button onClick={onOk}>
          {props.okText ? props.okText : transform('confirm')}
        </Button>
      </DialogActions>
    )
  }

  const {
    content,
    title,
    contentStyle,
    classes,
    disableBackdropClick,
    showClose = false,
    contentClass,
    dialogProps = {},
    style = {}
  } = props
  return (
    <Dialog
      open={open}
      aria-labelledby="confirmation-dialog-title"
      disableBackdropClick={disableBackdropClick}
      {...dialogProps}
      classes={{
        ...dialogProps.classes,
        paper: classnames(classes.paper, dialogProps.classes?.paper),
      }}
      id="dialogWatermark"
      style={style}
    >
      {(title && typeof title === 'string' && (
        <Title id="customized-dialog-title" onClose={onCancel}>
          {title}
        </Title>
      )) ||
        title}
      {showClose && (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onCancel}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent style={contentStyle} classes={{ root: contentClass }}>
        {content || props.children}
      </DialogContent>
      {footerShow()}
    </Dialog>
  )
}
export default withStyles(styles)(ConfirmDialog)
